<template>
  <div class="filter-container">
    <h2>{{ $t("filter") }}</h2>
    <div class="filter-elements">
      <div class="search-container" v-if="!isYrityskumppanit">
        <input
          type="search"
          :placeholder="$t('search')"
          v-model="itemStore.search"
          @keyup="changeSearch"
          @keydown="checkEnter"
        />
      </div>
      <button
        :class="getClass()"
        @click="itemStore.toggleSort()"
        v-if="itemStore.showSort && !isYrityskumppanit"
      >
        {{ itemStore.sortButtonText }}
      </button>
      <MonthButtons v-if="itemStore.showMonth" />
      <FilterButton
        v-for="term in itemStore.getPrimary"
        :key="term.slug"
        :term="term"
        :taxonomy="itemStore.taxonomy.primary"
      />
    </div>
    <div class="filter-elements second-row">
      <FilterButton
        v-for="term in itemStore.getSecondary"
        :key="term.slug"
        :term="term"
        :taxonomy="itemStore.taxonomy.secondary"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useItemStore } from "@/stores/items";
import FilterButton from "@/components/FilterButton.vue";
import { searchPosts } from "@/fetch";
import MonthButtons from "@/components/MonthButtons.vue";
import { computed } from "vue";

const itemStore = useItemStore();
const components = { FilterButton };

const isYrityskumppanit = computed(() => itemStore.type === "yrityskumppanit");

let timer: number = 0;

const checkEnter = (e: KeyboardEvent) => {
  // Prevent submit on enter.
  return e.key !== "Enter";
};

const changeSearch = (e: KeyboardEvent) => {
  clearTimeout(timer);
  if (e.key === "Enter") {
    // Search right away on Enter.
    doSearch();
  } else {
    // Delayed search on other buttons.
    timer = setTimeout(() => {
      doSearch();
    }, 700);
  }
};

const doSearch = () => {
  if (itemStore.search.length > 0) {
    itemStore.resetShow();
    searchPosts();
  }
};

const getClass = () => {
  let className = "btn sort";
  if (itemStore.sort) {
    className += itemStore.asc ? " asc" : " desc";
  }
  return className;
};
</script>

<style lang="scss">
.filter-container {
  padding-bottom: 1.5rem;
}

.filter-elements {
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;

  > * {
    flex: 0 0 auto;
  }
}
</style>
